import { DocumentDto, DocumentNode } from '../types/documents';

export function remapDescendantPaths(
  node: DocumentNode,
  oldPrefix: string,
  newPrefix: string
): DocumentNode {
  const nextPath = (p: string) => {
    if (p === oldPrefix) return newPrefix;
    if (p.startsWith(`${oldPrefix}/`)) return newPrefix + p.slice(oldPrefix.length);
    return p;
  };
  return {
    ...node,
    path: nextPath(node.path),
    fullPath: nextPath(node.fullPath),
    children: node.children.map((ch) => remapDescendantPaths(ch, oldPrefix, newPrefix)),
  };
}

export function mergeNodeWithRenameDto(node: DocumentNode, dto: DocumentDto): DocumentNode {
  const oldPath = node.path;
  const newPath = dto.path;
  const merged: DocumentNode = {
    ...node,
    title: dto.title,
    path: dto.path,
    fullPath: dto.fullPath ?? node.fullPath,
  };
  if (node.metadata && dto.metadata) {
    merged.metadata = {
      ...node.metadata,
      ...dto.metadata,
      fileName: dto.metadata.fileName ?? node.metadata.fileName,
    };
  }
  if (oldPath !== newPath && node.children?.length) {
    return {
      ...merged,
      children: node.children.map((ch) => remapDescendantPaths(ch, oldPath, newPath)),
    };
  }
  return merged;
}

export function applyRenameToTree(
  root: DocumentNode,
  nodeId: string,
  dto: DocumentDto
): DocumentNode {
  const update = (n: DocumentNode): DocumentNode => {
    if (n.id === nodeId) {
      return mergeNodeWithRenameDto(n, dto);
    }
    if (n.children?.length) {
      return { ...n, children: n.children.map(update) };
    }
    return n;
  };
  return update(root);
}

/** Diretório pai lógico a partir do path completo do arquivo (ex.: `/pasta/doc.edoc` → `/pasta`). */
export function parentPathFromDocumentPath(fullPath: string): string {
  const normalized = (fullPath || '').trim().replace(/\\/g, '/');
  if (!normalized || normalized === '/') return '/';
  const noTrailing = normalized.replace(/\/+$/, '');
  const lastSlash = noTrailing.lastIndexOf('/');
  if (lastSlash <= 0) return '/';
  return noTrailing.slice(0, lastSlash) || '/';
}
